import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Pagination.scss';

function PaginationContainer({ children, extraClassName }) {
    let className = styles['pagination-container'];
    if (extraClassName) {
        className += ` ${extraClassName}`;
    }

    return (
        <div className={className}>
            {children}
        </div>
    );
}

PaginationContainer.displayName = displayName('Pagination/PaginationContainer');

PaginationContainer.propTypes = {
    children: PropTypes.node.isRequired,
    extraClassName: PropTypes.string,
};

PaginationContainer.defaultProps = {
    extraClassName: '',
};

export default PaginationContainer;
